import React from 'react';
import PropTypes, { shape } from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

function CustomSelect({ value, label, options = [], handleChange }) {
  return (
    <FormControl variant="standard" sx={{ m: 1, width: '100%' }}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={handleChange} label={label}>
        <MenuItem value="">
          <em>Select the value</em>
        </MenuItem>
        {options.map((op) => (
          <MenuItem key={op.id} value={op.id}>
            {op.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

CustomSelect.defaultProps = {
  label: '',
};

CustomSelect.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default CustomSelect;
